// extracted by mini-css-extract-plugin
export default {"titleCart":"Favorite_titleCart__RtMjW"};